module.exports = __webpack_public_path__ + "img/icn_linkedin.ddba8dfa.svg";